import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCategoryRoutingModule } from './product-category-routing.module';

import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';

import { ProductCategoryComponent } from './product-category/product-category.component';
import { ProductCategoryHeaderComponent } from './product-category-header/product-category-header.component';
import { ProductCategoryNewCategoryDialogComponent } from './product-category-new-category-dialog/product-category-new-category-dialog.component';
import { ProductCategoryUpdateCategoryDialogComponent } from './product-category-update-category-dialog/product-category-update-category-dialog.component';
import { ProductCategoryDeleteDialogComponent } from './product-category-delete-dialog/product-category-delete-dialog.component';
import { ProductCategoryDataComponent } from './product-category-data/product-category-data.component';
import { ProductCategoryDataTableComponent } from './product-category-data-table/product-category-data-table.component';
import { ProductCategoryUpdateStepsDialogComponent } from './product-category-update-steps-dialog/product-category-update-steps-dialog.component';

@NgModule({
  declarations: [
    ProductCategoryComponent,
    ProductCategoryHeaderComponent,
    ProductCategoryNewCategoryDialogComponent,
    ProductCategoryUpdateCategoryDialogComponent,
    ProductCategoryDeleteDialogComponent,
    ProductCategoryDataComponent,
    ProductCategoryDataTableComponent,
    ProductCategoryUpdateStepsDialogComponent,
  ],
  imports: [
    CommonModule,
    ProductCategoryRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatMenuModule,
    MatDialogModule,
  ],
})
export class ProductCategoryModule {}
